import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import ActionButton from "../buttons/Action";
import LockIcon from "@material-ui/icons/Lock";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import {
  PageWrapper,
  Card,
  SetupWrapper,
  FormTitle,
  Field,
  Label,
  Input,
  Buttons,
} from "./MfaSharedLayout";

export default function MfaForm({ onSubmitCode, onCancel, isLoading, challengeName, onResetMfa }) {
  const [code, setCode] = useState("");
  const inputRef = useRef(null);
  const isTotp = challengeName === "SOFTWARE_TOKEN_MFA" || challengeName === "TotpRequired";
  const subtitle = isTotp
    ? "Abra seu app autenticador e informe o código temporário para continuar."
    : "Insira o código enviado por SMS/e-mail para continuar.";

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!code) return;
    onSubmitCode(code);
  };

  return (
    <PageWrapper>
      <Card>
        <SetupWrapper>
          <IconWrapper>
            <LockIcon style={{ fontSize: 48, color: '#2c3e50' }} />
          </IconWrapper>
          <FormTitle>Autenticação MFA</FormTitle>
          <FormSubtitle>{subtitle}</FormSubtitle>

          <form onSubmit={handleSubmit}>
            <Field>
              <Label htmlFor="mfa-code">Código MFA</Label>
              <Input
                ref={inputRef}
                id="mfa-code"
                type="text"
                inputMode="numeric"
                autoComplete="one-time-code"
                maxLength={10}
                placeholder="000000"
                value={code}
                onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
                required
              />
            </Field>
            <Buttons>
              <ActionButton
                icon={CheckCircleIcon}
                text={isLoading ? "Validando..." : "Confirmar"}
                type="submit"
                disabled={isLoading || !code}
                variant="primary"
                loading={isLoading}
              />
              <ActionButton
                icon={CancelIcon}
                text="Cancelar"
                type="button"
                onClick={onCancel}
                disabled={isLoading}
                variant="secondary"
              />
            </Buttons>
            {onResetMfa && (
              <ResetMfaLink onClick={onResetMfa} disabled={isLoading}>
                Não consegue acessar o código? Clique aqui
              </ResetMfaLink>
            )}
          </form>
        </SetupWrapper>
      </Card>
    </PageWrapper>
  );
}

const IconWrapper = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
`;

const FormSubtitle = styled.p`
  margin: 0 0 32px 0;
  color: #64748b;
  line-height: 1.5;
  text-align: center;
  font-size: 14px;
  font-family: 'Mulish', sans-serif;
`;

const ResetMfaLink = styled.div`
  margin-top: 16px;
  font-size: 13px;
  color: #667eea;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-family: 'Mulish', sans-serif;
  transition: color 0.2s ease;
  text-align: center;
  opacity: ${props => props.disabled ? 0.5 : 1};

  &:hover {
    color: ${props => props.disabled ? '#667eea' : '#764ba2'};
    text-decoration: ${props => props.disabled ? 'none' : 'underline'};
  }
`;
